<template>
    <div class="eval-page-container">
        <!-- main contents -->
        <EvalHeader :rightButtonHandler="goBackHandler" pageName="intro" :goHomeHandler="goHomeHandler" />
        <div class="eval-page">
            <div class="section-one">
                <div class="title-box">
                    <img class="icon" :src="require(`@/assets/images/icons/face-id.svg`)" />
                    <div class="title">외모 취향 평가</div>
                </div>
                <!-- <div class="icon-grid">
                    <div class="icon-box">
                        <div class="icon">🥰</div>
                        <div class="text">외모</div>
                    </div>
                    <div class="icon-box">
                        <div class="icon">💼</div>
                        <div class="text">직장</div>
                    </div>
                    <div class="icon-box">
                        <div class="icon">🏫</div>
                        <div class="text">학력</div>
                    </div>
                    <div class="icon-box">
                        <div class="icon">💵</div>
                        <div class="text">경제력</div>
                    </div>
                </div> -->
            </div>

            <div v-if="loading" class="loading-container">
                <DotFadeSpinner />
            </div>

            <div v-if="!loading" class="section-two">
                <!-- <div class="title">안내 사항</div> -->
                <div class="desc">
                    <p>조건적인 부분은 고려하지 말고, 오로지 외모를 기준으로만 평가해주세요.</p>
                    <p>오로지 외모 취향을 평가하기 위한 목적이며, 수락을 해도 실제 소개팅이 진행되지 않습니다.</p>
                    <p>수락을 많이 하거나 적게 하는 것에 불이익은 전혀 없습니다.</p>
                </div>
            </div>

            <div v-if="!loading" class="section-three">
                <button class="btn" @click="goNextPage" :disabled="loading">
                    <p class="label f-regular">시작하기</p>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
// import userService from '@/services/user'
import EvalHeader from './EvalHeader.vue'

export default {
    name: 'EvaluationIntroPage',
    components: {
        EvalHeader,
    },
    data: () => ({
        loading: true,
    }),
    computed: {
        me() {
            return this.$store.getters.me || {}
        },
        aiRating() {
            return (this.me.ai_ratings || []).find(item => item.status === 'created' || item.status === 'in_progress')
        },
    },
    watch: {
        'aiRating.evaluation_data': {
            handler(newVal) {
                if (newVal) {
                    // console.log('newVal', newVal)
                    this.loading = false
                    const parsedVal = JSON.parse(newVal)
                    const currentIndex = parsedVal.findIndex(
                        item => item.is_look_accepted === null && item.is_enabled === true
                    )
                    // console.log('currentIndex', currentIndex)
                    if (currentIndex < 0) {
                        this.finishEvaluation()
                    }
                }
            },
            immediate: true,
        },
    },
    methods: {
        goBackHandler() {
            this.$router.go(-1)
        },
        goHomeHandler() {
            this.$router.go(-1)
        },
        async goNextPage() {
            console.log('goNextPage called')
            this.$router.push('/evaluation/main')

            // 시작하기 전에 평가 대상에 제외할 사람 있는지 확인하고 평가대상 새로고침 진행
            // const res = await userService.refreshAiRating(this.me.id)
            // if (res.msg.indexOf('refreshed') === -1) {
            //     console.log('외모 평가를 재생성하지 않았습니다.')
            //     this.$router.push('/evaluation/main')
            //     return
            // }

            // console.log('외모 평가를 재생성 했습니다.')
            // this.loading = true
            // // aiRating.evaluation_data 정보 리프레시 하고 진행해야함.
            // await this.$store.dispatch('loadMe')

            // const refreshedRating = (this.$store.getters.me.ai_ratings || []).find(item => item.status === 'created')

            // if (refreshedRating && refreshedRating.evaluation_data) {
            //     this.$router.push('/evaluation/main')
            // } else {
            //     // fallback, 혹은 error handling
            //     console.error('리프레시 후 aiRating 데이터를 찾을 수 없습니다.')
            // }
        },
        async finishEvaluation(hasTargets = true) {
            const idx = await this.$modal.basic({
                title: hasTargets ? 'AI 외모취향 평가 완료' : '외모취향 평가',
                body: hasTargets
                    ? '외모 취향 평가가 완료되었습니다.<br/>AI 외모 추천의 성능은 데이터가 많을수록 정확해집니다.<br/>본 평가 이외에도 수락/거절 사유를 잘 선택해주세요 :)'
                    : '평가 대상 인원이 충분하지 않습니다. 인원이 확보되면 다시 평가 요청 드리도록 하겠습니다.',
                buttons: [
                    {
                        label: '확인',
                        class: 'btn-primary',
                    },
                ],
                preventCloseOnMousedownMask: true,
            })
            if (idx === 0) {
                this.$router.push({ name: 'HomePage' })
            }
        },
    },
}
</script>

<style lang="scss" scoped>
.loading-container {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .loading-message {
        margin-top: 16px;
        color: black;
        font-size: 14px;
    }
}

.eval-page {
    padding-left: 20px;
    padding-right: 20px;
}
.section-one {
    /* margin: 0 0 45px 0; */

    .title-box {
        margin-bottom: 23px;

        .icon {
            margin-bottom: 8px;
            width: 30px;
            height: 30px;
            flex-shrink: 0;
            aspect-ratio: 1/1;
        }

        .title {
            color: var(--Gray-313131, #313131);
            text-align: center;
            font-feature-settings: 'liga' off, 'clig' off;
            font-family: Pretendard;
            font-size: 24px;
            font-style: normal;
            font-weight: 700;
            line-height: 140%; /* 33.6px */
        }
    }

    .icon-grid {
        display: grid;
        // grid-template-columns: repeat(2, minmax(0, 1fr));
        grid-template-columns: repeat(2, 100px); /* 아이템 고정 너비 */
        grid-auto-rows: 110px; /* 각 줄의 높이 고정 */
        justify-content: center; /* 그리드 전체를 가로 중앙 정렬 */
        gap: 6px;

        .icon-box {
            width: 100px;
            height: 110px;
            background-color: #f3f6ff;
            border-radius: 6px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            color: white;
            font-weight: bold;

            .icon {
                font-size: 50px;
                font-family: Pretendard;
            }
            .text {
                font-size: 15px;
                font-family: Pretendard;
                font-weight: bold;
                color: #313131;
            }
        }
    }

    .percent-box {
        display: flex;
        flex-direction: row;
        align-items: end;
        justify-content: center;
        position: relative;

        &.version-one {
            // background-color: #E6EBFF;
            // backdrop-filter: blur(16.75px) opacity(80%);

            .background {
                position: absolute;
                width: 245px;
                height: 100%;
                z-index: 0;

                background-color: #e6ebff;
                opacity: 0.8;
                filter: blur(16.75px);
            }
        }
        &.version-two {
        }

        .number {
            z-index: 1;
            color: #3452d5;
            text-align: center;
            font-feature-settings: 'liga' off, 'clig' off;
            font-family: Pretendard;
            font-size: 70px;
            font-style: normal;
            font-weight: 700;
            line-height: 70%; /* 49px */
            letter-spacing: 5px;
        }

        .symbol {
            z-index: 1;
            color: #3452d5;
            font-feature-settings: 'liga' off, 'clig' off;
            font-family: Pretendard;
            font-size: 40px;
            font-style: normal;
            font-weight: 700;
            line-height: 70%;
            letter-spacing: 5px;
        }
    }

    .desc {
        margin-top: 24px;
        color: var(--Grey-787878, #787878);
        text-align: center;
        font-feature-settings: 'liga' off, 'clig' off;
        font-family: Pretendard;
        font-size: 12px;
        font-style: normal;
        font-weight: 500;
        line-height: 150%; /* 22.5px */
    }
}
.section-two {
    .title {
        color: #3a3a3a;
        text-align: left;
        font-family: Pretendard;
        font-size: 17px;
        font-style: normal;
        font-weight: 600;

        margin-bottom: 18px;
    }
    .desc {
        // padding-left: 16px;

        color: #3a3a3a;
        text-align: left;
        font-feature-settings: 'liga' off, 'clig' off;
        font-family: Pretendard;
        font-size: 13px;
        font-style: normal;
        font-weight: 500;
        line-height: 150%; /* 22.5px */

        width: 300px;
        margin: 0 auto;

        > p {
            // text-indent: -16px;
            position: relative;
            padding-left: 16px;
            margin-top: 4px;
        }
        > p:first-child {
            margin-top: 0px;
        }
        > p::before {
            content: '•';
            position: absolute;
            left: 0;
            top: 0;
            line-height: inherit;
        }
    }
}
.section-three {
    button {
        height: 52px;
        width: 100%;
        font-size: 15px;
        background: var(--Green, #0a7);
        color: white;
        border-radius: 32px;
        border-width: 0;
        @include spoqa-f-medium;

        margin: 40px 0 20px 0;

        p {
            color: #fdfcfa;
            font-feature-settings: 'liga' off, 'clig' off;
            font-family: Pretendard;
            font-size: 17px;
            font-style: normal;
            font-weight: 600;
            line-height: 100%;
        }
    }
}
</style>
